import { setSessionInfo } from 'actions';
import { connect } from 'react-redux';

import JSX from '../Logout';

const mapDispatchToProps = (dispatch) => ({
    setSessionInfo: (sessionInfo) => dispatch(setSessionInfo(sessionInfo))
});

export default connect(null, mapDispatchToProps)(JSX);
